module.exports = __webpack_public_path__ + "img/consultoria_4-3.4d3d2dfa.webp";